/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Auth_Email_LabelInputs */

const en_work_order_publish_auth_email_label = /** @type {(inputs: Work_Order_Publish_Auth_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

const fr_work_order_publish_auth_email_label = /** @type {(inputs: Work_Order_Publish_Auth_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse e-mail`)
};

const de_work_order_publish_auth_email_label = /** @type {(inputs: Work_Order_Publish_Auth_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

const it_work_order_publish_auth_email_label = /** @type {(inputs: Work_Order_Publish_Auth_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indirizzo e-mail`)
};

const ru_work_order_publish_auth_email_label = /** @type {(inputs: Work_Order_Publish_Auth_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Адрес электронной почты`)
};

const es_work_order_publish_auth_email_label = /** @type {(inputs: Work_Order_Publish_Auth_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirección de correo electrónico`)
};

const zh_cn2_work_order_publish_auth_email_label = /** @type {(inputs: Work_Order_Publish_Auth_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮件`)
};

const ja_work_order_publish_auth_email_label = /** @type {(inputs: Work_Order_Publish_Auth_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電子メールアドレス`)
};

const hi_work_order_publish_auth_email_label = /** @type {(inputs: Work_Order_Publish_Auth_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेल पता`)
};

const pt_pt2_work_order_publish_auth_email_label = /** @type {(inputs: Work_Order_Publish_Auth_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço de email`)
};

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Work_Order_Publish_Auth_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_auth_email_label = /** @type {((inputs?: Work_Order_Publish_Auth_Email_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Auth_Email_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_auth_email_label(inputs)
	if (locale === "de") return de_work_order_publish_auth_email_label(inputs)
	if (locale === "it") return it_work_order_publish_auth_email_label(inputs)
	if (locale === "ru") return ru_work_order_publish_auth_email_label(inputs)
	if (locale === "es") return es_work_order_publish_auth_email_label(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_auth_email_label(inputs)
	if (locale === "ja") return ja_work_order_publish_auth_email_label(inputs)
	if (locale === "hi") return hi_work_order_publish_auth_email_label(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_auth_email_label(inputs)
	return en_work_order_publish_auth_email_label(inputs)
});